import api from '../../../lib/Api'
import { addNotification } from '../../notifications'
import * as types from '../../actionTypes'

export const fetchingPreviewMerge = () => ({
  type: types.FETCHING_PREVIEW_MERGE,
})

export const fetchingPreviewMergeSuccess = previewMergeCustomerResults => ({
  type: types.FETCHING_PREVIEW_MERGE_SUCCESS,
  previewMergeCustomerResults,
})

export const fetchingPreviewMergeError = previewMergeCustomerError => ({
  type: types.FETCHING_PREVIEW_MERGE_ERROR,
  previewMergeCustomerError,
})

export const fetchAndHandlePreviewMerge = mergeParameters => {
  return async function(dispatch) {
    dispatch(fetchingPreviewMerge())
    const { activePrimaryId, activeDuplicateId } = mergeParameters
    const primaryId = mergeParameters[activePrimaryId]
    const duplicateId = mergeParameters[activeDuplicateId]
    if (primaryId && duplicateId) {
      try {
        const response = await api.get(
          `/netsuitecustomers/dedupe?${activePrimaryId}=${primaryId}&${activeDuplicateId}=${duplicateId}`,
        )
        const data = response.data !== '' ? response.data : null
        dispatch(fetchingPreviewMergeSuccess(data))
      } catch (error) {
        const { response } = error
        const { data } = response || {}
        const { detail } = data || {}
        const errorMessage = detail || error.toString()
        dispatch(
          addNotification({
            color: 'danger',
            text: errorMessage,
          }),
        )
        dispatch(fetchingPreviewMergeError(errorMessage))
      }
    } else {
      dispatch(
        fetchingPreviewMergeError('missing Ids for primary or duplicate'),
      )
    }
  }
}

export const mergingCustomers = () => ({
  type: types.MERGING_CUSTOMERS,
})

export const mergingCustomersSuccess = mergeCustomerResults => ({
  type: types.MERGING_CUSTOMERS_SUCCESS,
  mergeCustomerResults,
})

export const mergingCustomersError = mergeCustomerError => ({
  type: types.MERGING_CUSTOMERS_ERROR,
  mergeCustomerError,
})

export const mergeAndHandleCustomers = mergeParameters => {
  return async function(dispatch) {
    dispatch(mergingCustomers())
    const { activePrimaryId, activeDuplicateId } = mergeParameters
    const primaryId = mergeParameters[activePrimaryId]
    const duplicateId = mergeParameters[activeDuplicateId]
    if (primaryId && duplicateId) {
      try {
        const response = await api.post(`/netsuitecustomers/dedupe`, {
          [activePrimaryId]: primaryId,
          [activeDuplicateId]: duplicateId,
        })

        const friendyPrimaryIdType =
          activePrimaryId === 'primaryNSCustomerId' ? 'NS' : 'SS'
        const friendyDuplicateIdType =
          activeDuplicateId === 'duplicateNSCustomerId' ? 'NS' : 'SS'

        dispatch(
          addNotification({
            color: 'success',
            text: `You have sucessfully merged ${friendyDuplicateIdType} License ID ${duplicateId} with ${friendyPrimaryIdType} License ID ${primaryId}`,
          }),
        )
        const data = response.data !== '' ? response.data : null
        dispatch(mergingCustomersSuccess(data))
      } catch (error) {
        const { response } = error
        const { data } = response || {}
        const { detail } = data || {}
        const errorMessage = detail || error.toString()
        dispatch(
          addNotification({
            color: 'danger',
            text: errorMessage,
          }),
        )
        dispatch(mergingCustomersError(errorMessage))
      }
    } else {
    }
  }
}

const initialState = {
  isFetchingPreviewMerge: false,
  previewMergeCustomerResults: null,
  previewMergeCustomerError: null,
  isMerging: false,
  mergeCustomerResults: null,
  mergeCustomerError: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCHING_PREVIEW_MERGE:
      return {
        ...state,
        isFetchingPreviewMerge: true,
      }
    case types.FETCHING_PREVIEW_MERGE_SUCCESS:
      return {
        ...state,
        isFetchingPreviewMerge: false,
        mergeCustomerResults: null,
        mergeCustomerError: null,
        previewMergeCustomerResults: action.previewMergeCustomerResults,
        previewMergeCustomerError: null,
      }
    case types.FETCHING_PREVIEW_MERGE_ERROR:
      return {
        ...state,
        isFetchingPreviewMerge: false,
        mergeCustomerResults: null,
        mergeCustomerError: null,
        previewMergeCustomerResults: null,
        previewMergeCustomerError: action.previewMergeCustomerError,
      }
    case types.MERGING_CUSTOMERS:
      return {
        ...state,
        isMerging: true,
      }
    case types.MERGING_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isMerging: false,
        mergeCustomerResults: action.mergeCustomerResults,
        mergeCustomerError: null,
        previewMergeCustomerResults: null,
        previewMergeCustomerError: null,
      }
    case types.MERGING_CUSTOMERS_ERROR:
      return {
        ...state,
        isMerging: false,
        mergeCustomerResults: null,
        mergeCustomerError: action.mergeCustomerError,
        previewMergeCustomerResults: null,
        previewMergeCustomerError: null,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/merge/mergeManager.js